<template>
  <div>
    <van-row
      type="flex"
      justify="center"
      align="center"
      :style="{ height: contentHeight + 'px' }"
    >
      <van-col class="loading">
        <van-row
          type="flex"
          justify="center"
          align="center"
          style="height:50px;"
        >
          <van-col>
            <van-loading type="spinner" color="black" />
          </van-col>
        </van-row>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import combineURLs from "axios/lib/helpers/combineURLs.js";
import { mapState, mapActions } from "vuex";
import appConsts from "@/store/consts.js";
import memberService from "@/services/memberService.js";
import tokenService from "@/services/tokenService.js";

export default {
  computed: {
    contentHeight() {
      return document.documentElement.clientHeight;
    },
    ...mapState({
      options: (state) => state.orderModule.options,
      member: state => state.memberModule.member
    })
  },
  async created() {
    var path="/";
    if(this.$route.query && this.$route.query.token)
    {
      let tokenResult = await memberService.loginFromGDHRSSAsync({
        token: this.$route.query.token
      });
      // tokenService.setToken(tokenResult.access_token);
      tokenService.setToken(tokenResult);
      await this.loadOrderOptionsAsync();
      await this.loadMemberAsync();
     
      if (this.$route.query.redirect) {
        const redirect = this.$route.query.redirect;
        path = combineURLs("/", redirect);
      }
      this.$router.replace(path);
    }
    else
    {
        this.$dialog.alert({
            message: "参数token不存在，请关闭页面重新打开",
        }).then(() => {
            // on close
            location.replace("about:blank");
            
            return;
        });

    }
    
    
  },
  methods: {
    ...mapActions("memberModule", [appConsts.loadMemberAsync]),
    ...mapActions("orderModule", [appConsts.loadOrderOptionsAsync]),
  }
}; 
</script>

<style lang="scss" scoped>
.loading {
  background-color: rgb(124, 124, 124);
  width: 50px;
  height: 50px;
  border-radius: 5%;
}
</style>
